import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { isNoteSidebarJump, pendingNoteSidebarActionsAtom } from '@/atoms/editor';

/**
 * Ask before the tab closes while any sidebar gesture is still parked — it was
 * never written, and the queue doesn't survive a reload. Mounted app-wide
 * (Layout) because the queue outlives the Editor screen.
 */
export function useParkedNoteGesturesUnloadGuard(): void {
    const hasUnlandedWrites = useAtomValue(pendingNoteSidebarActionsAtom).some(gesture => !isNoteSidebarJump(gesture));
    useEffect(() => {
        if (!hasUnlandedWrites) return;
        const onBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            // Chrome < 119 asks only when `returnValue` is set.
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, [hasUnlandedWrites]);
}
